import Swal from "sweetalert2";
import moment from "moment-timezone";

export const handleSeasonSelect = async (
  carId,
  basePrice,
  seasonKey,
  {
    seasons,
    setSettingSeasonalPrice,
    fetchData,
    cars,
    rentals,
    coupons,
    contact,
    drivers,
    tours,
    tourBookings,
    employeeService,
    setCarsData,
    setRentalsData,
    setCouponsData,
    setTransfersData,
    setDriversData,
    setToursData,
    setTourBookingsData,
    setEmployeesData,
    setSeasonalPricing,
    setIsLoading,
    setError,
  }
) => {
  const season = seasons[seasonKey];

  try {
    setSettingSeasonalPrice({ carId, season: seasonKey });
    const result = await Swal.fire({
      title: `Set ${season.name} Prices`,
      html: `
          <div class="mb-4">
            <p class="text-sm text-gray-600">${season.description}</p>
          </div>
          <div class="form-group">
            <label class="block text-sm font-medium text-gray-700 mb-1">Price per day (€)</label>
            <input 
              id="seasonPrice" 
              type="number" 
              class="w-full px-3 py-2 border rounded-md"
              value="${basePrice}"
              min="1"
              step="any"
            >
          </div>
        `,
      showCancelButton: true,
      confirmButtonText: "Set Prices",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#1e3a8a", // blue-900
      preConfirm: () => {
        const price = document.getElementById("seasonPrice").value;
        if (!price || price <= 0) {
          Swal.showValidationMessage("Please enter a valid price");
          return false;
        }
        return price;
      },
    });

    if (result.isConfirmed) {
      const price = parseFloat(result.value);

      // Show loading state with progress
      const loadingAlert = Swal.fire({
        title: "Setting Seasonal Prices",
        html: "Processing dates...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      // Process each date range for the season
      for (const range of season.ranges) {
        const dates = [];
        let currentDate = moment
          .tz(range.start, "Europe/Athens")
          .startOf("day");
        const endDate = moment.tz(range.end, "Europe/Athens").startOf("day");

        while (currentDate.isSameOrBefore(endDate)) {
          dates.push({
            date: currentDate.toDate(),
            isAvailable: true,
            dynamicPrice: price,
          });
          currentDate = currentDate.clone().add(1, "day");
        }

        // Update all dates in the range
        await Promise.all(
          dates.map((dateData) => cars.updateAvailability(carId, dateData))
        );
      }

      await loadingAlert.close();
      await Swal.fire({
        icon: "success",
        title: "Prices Updated",
        text: `${season.name} prices have been set to €${price} per day`,
        confirmButtonColor: "#1e3a8a",
      });

      fetchData();
    }
  } catch (error) {
    console.error("Error setting seasonal prices:", error);
    await Swal.fire({
      icon: "error",
      title: "Error",
      text: "Failed to update seasonal prices. Please try again.",
      confirmButtonColor: "#1e3a8a",
    });
  } finally {
    setSettingSeasonalPrice(null);
  }
};
